import React from 'react';
import {Col} from 'antd';
import {Link} from 'react-router-dom';
import DocumentMeta from 'react-document-meta';
import {faqMeta} from '../constants/meta';
import {Section, PageHeader} from '../common'

const Faq = () => {
  return (
    <DocumentMeta {...faqMeta}>
      <PageHeader title="Често задавани въпроси" />
      <Section>
        <Col>
          <h2>Какви материали разработвате?</h2>
          <p>Изготвяме всякакви материали за всички икономически специалности. Разработваме курсови и дипломни работи. Пишем реферати, есета, казуси и всичко, което се изисква в процеса на вашето следване.</p>
          <p>Решаваме задачи по математика от 1-ви до 12-ти клас.</p>
          <p>Изготвяме PowerPoint презентации.</p>
          <p>Можем да ви помогнем с вашите задания в Excel.</p>
          <p>Свържете се с нас за вашата задача, тема, изискване или допълнителни въпроси.</p>

          <h2>За колко време ще е готово заданието?</h2>
          <p>Времето за разработка зависи от сложността и изискванията на заданието.</p>
          <p>Минималните срокове са:</p>
          <ul>
            <li>средно между 7 - 10 дни за решаване на задачи, казуси, курсови работи, реферати, есета и др.</li>
            <li>средно между 30 - 45 дни за дипломна работа и магистърска теза.</li>
          </ul>
          <p>Разбира се, тези срокове са силно ориентировъчни, като зависят от нашето моментно натоварване, спецификата и сложността на изпратеното задание и най-вече от вашите срокове за представяне на разработката.</p>
          <p>Може да заявите приоритетна разработка, с която заданието ще бъде изпълнено възможно най-скоро.</p>
          <p>Свържете се с нас за конкретна оферта.</p>

          <h2>Предлагате ли готови разработки и материали?</h2>
          <p>Ние не предлагаме готови разработки и материали под никаква форма. Разработените от нас работи са строго индивидуални и след предоставянето на клиентите не ги предлагаме в никаква форма на сайтове за готови материали.</p>

          <h2>Каква е цената?</h2>
          <p>Цената при нас не се определя на брой страници, а зависи от сложността, изискванията на заданието и срока, в който желаете да бъде разработено.</p>
          <p>Свържете се с нас за повече подробности за конкретния въпрос.</p>

          <h2>Какви услуги предлагате за дистанционно обучение?</h2>
          <p>Ние предлагаме пълно съдействие по време на вашето дистанционно обучение за всяка икономическа специалност. Можем да ви консултираме за избор на учебно заведение и специалност. Когато работим заедно, следим учебния план, сроковете и заданията на всички зададени курсови разработки, казуси, реферати и др, които трябва да предадете. За успешното ваше представяне можем да ви помогнем в тяхната подготовка и предаване по изисквания от учебното заведение начин. Предлагаме и компетентна помощ при решаване на всякакви тестове в онлайн формат, от които имате нужда.</p>
          <p>Пишете ни за повече информация, избор на университет или специалност и изготвяне на план за действие.</p>
        
          <h2>Как може да ми помогнете за решаване на задачи по Математика от 1-ви до 12-ти клас?</h2>
          <p>Ако имате нужда от помощ за решаване на задачи по Математика от 1-ви до 12-ти клас, просто ни ги изпратете и ние ще ви помогнем.</p>
        
          <h2>А решавате ли задачи по Математика за висши училища?</h2>
          <p>Можем да помогнем и за това, но поради спецификата и сложността на преподавания материал по Висша математика в отделните университети у нас, е необходимо да изпратите исканото задание. След това ще може да отговорим дали това е от нашата компенетност.</p>
        
          <h2>Как може да ми помогнете за изготвяне на презентация на PowerPoint?</h2>
          <p>Голяма част от разработките в училищата и висшите училища у нас, изискват разработването им като презентации. Ако имате нужда от това, пишете ни. </p>
        
          <h2>Иматe трудности при работа с Excel?</h2>
          <p>Разполагаме с квалифицирани сътрудници при работа с електронни таблици от типа Excel.</p>
          <p>Свържете се с нас за повече подробности и конкретен отговор.</p>

          <h2>Как се прави поръчка за разработване на индивидуална курсова и дипломна работа, реферат, есе, теза, задача казус и др.?</h2>
          <p>За да поръчате разработка на дадено задание трябва да се свържете с нас чрез формата за поръчки/запитване или по телефон или имейл. За нас е необходимо да знаем срока, за който искате да бъде изпълнена поръчката, вида, темата и допълнителни изисквания ако има такива. След като се свържете с нас, в най-кратък срок ще получите обратна връзка за доуточняване на подробности и/или цената. Ще получите вашата разработка в уговорения предварително срок.</p>

          <h2>Има ли възможност разработката ми да е плагиатствана от друг материал в интернет?</h2>
          <p>Не, няма такава възможност. Нашият екип гарантира професионален и индивидуален подход. Писмените разработки са индивидуални за всяка ваша поръчка.</p>

          <h2>Има ли рискове при поръчка на дипломна или курсова работа?</h2>
          <p>Нашият екип гарантира пълна конфиденциалност на клиентите си. Ние гарантираме качество на разработките, спазвайки всички предварително уточнени изисквания. Ако сме поели вашата поръчка, ние гарантираме тя да бъде разработена спрямо нашите високи стандарти.</p>
          <p>Ние сме тук, за да ви помогнем!</p>
        </Col>
      </Section>
    </DocumentMeta>
  );
};

export default Faq;